import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Page imports - load critical pages directly for better performance
import HomePage from './pages/home-landing-page/index';
import Dashboard from './pages/dashboard/index';
import Login from './pages/login/index';
import Register from './pages/register/index';
import EmailConfirmation from './pages/EmailConfirmation';
import NotFound from './pages/NotFound';
import ResetPassword from './pages/reset-password/index';
import ProfileSettings from './pages/profile-settings/index';
import PrivacyPolicy from './pages/privacy-policy/index';
import TermsOfService from './pages/terms-of-service/index';
import Security from './pages/security/index';
import SubscriptionManagement from './pages/subscription-management/index';
import BillingHistory from './pages/billing-history/index';
import HelpSupport from './pages/help-support/index';
import SystemDiagnostics from "./pages/system-diagnostics";

// Feature modules
import CommunicationHub from './pages/communication-hub/index';
import LeadManagement from './pages/lead-management/index';
import LeadDiscovery from './pages/lead-discovery/index';
import FunnelManagement from './pages/funnel-management/index';
import FunnelBuilder from './pages/funnel-builder/index';
import CalendarScheduling from './pages/calendar-scheduling/index';
import AnalyticsDashboard from './pages/analytics-dashboard/index';
import WorkflowManagement from './pages/workflow-management/index';
import WorkflowBuilder from './pages/workflow-builder/index';
import AIBuildMarketingFunnels from './pages/ai-build-marketing-funnels/index';
import AISalesCloser from './pages/ai-sales-closer/index';
import AILeadFinderAndScrubber from './pages/ai-lead-finder-and-scrubber/index';
import AITemplateStudio from './pages/ai-template-studio/index';
import SalesFunnelManagement from './pages/sales-funnel-management/index';
import FunnelAnalytics from './pages/funnel-analytics/index';
import ApiKeysManagement from './pages/api-keys-management/index';
import ApiKeys from './pages/api-keys/index';
import AILeadScoringSystem from './pages/ai-lead-scoring-system';
import ROITrackingDashboard from './pages/roi-tracking-dashboard';
import AIPersonFinder from './pages/ai-person-finder/index';
import GoHighLevelIntegration from './pages/gohighlevel-integration/index';
import AIDialer from './pages/ai-dialer/index';
import CrossPlatformIntegrationHub from './pages/cross-platform-integration-hub/index';
import AutomationWorkflowDesigner from './pages/automation-workflow-designer/index';
import IntegrationAnalyticsMonitoring from './pages/integration-analytics-monitoring/index';
import AutomatedTestFlow from './pages/automated-test-flow/index';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/security" element={<Security />} />
          
          {/* Protected Routes - Dashboard & Profile */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile-settings" element={<ProfileSettings />} />
          <Route path="/subscription-management" element={<SubscriptionManagement />} />
          <Route path="/billing-history" element={<BillingHistory />} />
          <Route path="/help-support" element={<HelpSupport />} />
          
          {/* Core Features */}
          <Route path="/communication-hub" element={<CommunicationHub />} />
          <Route path="/lead-management" element={<LeadManagement />} />
          <Route path="/lead-discovery" element={<LeadDiscovery />} />
          <Route path="/funnel-management" element={<FunnelManagement />} />
          <Route path="/funnel-builder" element={<FunnelBuilder />} />
          <Route path="/calendar-scheduling" element={<CalendarScheduling />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/workflow-management" element={<WorkflowManagement />} />
          <Route path="/workflow-builder" element={<WorkflowBuilder />} />
          
          {/* AI-Powered Features */}
          <Route path="/ai-build-marketing-funnels" element={<AIBuildMarketingFunnels />} />
          <Route path="/ai-sales-closer" element={<AISalesCloser />} />
          <Route path="/ai-lead-finder-and-scrubber" element={<AILeadFinderAndScrubber />} />
          <Route path="/ai-template-studio" element={<AITemplateStudio />} />
          <Route path="/ai-lead-scoring-system" element={<AILeadScoringSystem />} />
          <Route path="/roi-tracking-dashboard" element={<ROITrackingDashboard />} />
          <Route path="/ai-person-finder" element={<AIPersonFinder />} />
          <Route path="/gohighlevel-integration" element={<GoHighLevelIntegration />} />
          <Route path="/ai-dialer" element={<AIDialer />} />
          <Route path="/cross-platform-integration-hub" element={<CrossPlatformIntegrationHub />} />
          <Route path="/automation-workflow-designer" element={<AutomationWorkflowDesigner />} />
          <Route path="/integration-analytics-monitoring" element={<IntegrationAnalyticsMonitoring />} />
          
          {/* Advanced Features */}
          <Route path="/sales-funnel-management" element={<SalesFunnelManagement />} />
          <Route path="/funnel-analytics" element={<FunnelAnalytics />} />
          <Route path="/api-keys-management" element={<ApiKeysManagement />} />
          <Route path="/api-keys" element={<ApiKeys />} />
          
          {/* System Diagnostics Route */}
          <Route path="/system-diagnostics" element={<SystemDiagnostics />} />
          <Route path="/automated-test-flow" element={<AutomatedTestFlow />} />
          
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;